"use client"

import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { useSetQualityEnabledMutation } from "@/hooks/mutations/conversation-quality"

/** The tenant's own switch — «Reviews», since the page's title already says what. Rendered only where the caller may flip it. */
export function QualityAccessSwitch({ enabled }: { enabled: boolean }) {
  const setEnabled = useSetQualityEnabledMutation()

  return (
    <div className="flex h-10 items-center gap-2 rounded-md border px-3">
      <Switch
        id="conversation-quality-enabled"
        checked={enabled}
        disabled={setEnabled.isPending}
        onCheckedChange={(checked) => setEnabled.mutate({ enabled: checked })}
      />
      <Label htmlFor="conversation-quality-enabled" className="text-sm font-medium">
        Reviews
      </Label>
    </div>
  )
}
